<template>
  <div>
    <page-header>
      <template #breadcrumbs> Роли </template>
      <h2>Роли</h2>
      <template #actions>
        <div class="actions">
          <button-component v-if="canEdit" @click="editCard(0)">
            Создать
          </button-component>
          <button-component
            kind="tertiary"
            :class="{ filtered: isFiltered }"
            @click="modals.filter = !modals.filter"
          >
            <template #prepend>
              <icon-component class="mr-2" name="filter" />
            </template>
            Фильтр
          </button-component>
        </div>
      </template>
    </page-header>
    <section class="content">
      <template v-if="page">
        <template v-if="page.items.length">
          <div class="table-inner">
            <table class="table-custom">
              <thead>
                <tr>
                  <th width="50px"></th>
                  <th class="text-center">ID</th>
                  <th>Название</th>
                  <th>Активность</th>
                  <th>Дата создания</th>
                  <th>Дата изменения</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="role in page.items"
                  :key="role.id"
                  v-on:dblclick="editCard(role.id)"
                >
                  <td>
                    <menu-component class="actions" :actions="actions(role)" />
                  </td>
                  <td class="text-center">{{ role.id }}</td>
                  <td>{{ role.name }}</td>
                  <td>{{ role.isDisabled ? "Нет" : "Да" }}</td>
                  <td>{{ $momentFormat(role.created, "DD.MM.YYYY HH:mm") }}</td>
                  <td>
                    {{ $momentFormat(role.modified, "DD.MM.YYYY HH:mm") }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-if="page.pagesTotal > 1">
            <Pagination
              :page-count="page.pagesTotal"
              :current-page="page.pageNumber"
              @change="onPageChange($event)"
            />
          </div>
          <div>
            <PageCounter
              :isFiltered="isFiltered"
              :totalCount="totalCount"
              :filteredCount="page.itemsTotal"
            />
          </div>
        </template>
        <template v-else>
          <EmptyListMessage />
        </template>
      </template>
      <section class="modals">
        <transition name="filter">
          <div class="filter" v-if="modals.filter">
            <RolesFilter
              v-bind:filters="filters"
              v-on:apply="onFiltersApply($event)"
              v-on:reset="onFiltersReset($event)"
            />
          </div>
        </transition>
      </section>
    </section>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ButtonComponent from "@/common/ui/ButtonComponent";
import IconComponent from "../../../common/ui/IconComponent";
import PageHeader from "../../../common/components/page/PageHeader";
import RolesFilter from "../components/RolesFilter";
import Constants from "../../../common/constants";
import API from "../api/roles";
import security from "../../../common/mixins/security";
import MenuComponent from "@/common/ui/components/page/MenuComponent";
import filtermanager from "../../../common/mixins/filtermanager";
import PageCounter from "@/common/components/PageCounter";

export default {
  name: "Roles",
  components: {
    MenuComponent,
    RolesFilter,
    PageHeader,
    IconComponent,
    ButtonComponent,
    PageCounter,
  },
  mixins: [security, filtermanager],
  created() {
    //загрузить по-умолчанию
    this.request.pageNumber = this.$route.query.page ? this.$route.query.page * 1 : 1;
    this.checkPermission(Constants.RoleEdit).then((response) => {
      this.canEdit = response.data;
    });
    this.getTotalCount();
    this.loadPage();
  },
  data() {
    return {
      request: {
        pageNumber: 1,
        pageSize: Constants.pageSize,
      },
      filters: {
        name: "",
        active: null,
      },
      modals: {
        filter: false,
      },
      canEdit: true,
      isFiltered: false,
      totalCount: 0,
    };
  },
  methods: {
    getTotalCount() {
      const self = this;
      API.search({ pageNumber: 1, pageSize: 1 }).then(function (response) {
        self.totalCount = response.data.itemsTotal;
      });
    },
    actions(item) {
      return [
        {
          title: "Просмотр",
          icon: "eye",
          click: () =>
            this.$router.push({
              name: "roleCard",
              params: { action: "view", id: item.id },
            }),
        },
        {
          title: "Редактировать",
          icon: "pen",
          click: () =>
            this.$router.push({
              name: "roleCard",
              params: { action: "edit", id: item.id },
            }),
        },
        {
          title: "Удалить",
          icon: "trash",
          click: () => this.deleteCard(item.id),
        },
      ];
    },
    onPageChange(pageNumber) {
      this.request.pageNumber = pageNumber;
      this.$router.push({
          query: {
              ...this.$route.query,
              page: pageNumber
            }
      });
      this.loadPage();
    },
    loadPage() {
      const filter = this.loadFilter();
      if (filter) {
        this.filters = filter;
        this.isFiltered = true;
      }
      this.$store.dispatch(
        "admin/roles/searchRoles",
        Object.assign(this.filters, this.request)
      );
    },
    editCard(id) {
      this.$router.push({
        name: "roleCard",
        params: { action: "edit", id: id },
        query: { page: this.request.pageNumber }
      });
    },
    deleteCard(id) {
      Constants.alert.fire(Constants.confirmOptions.delete).then((res) => {
        if (res.isConfirmed) {
          API.delete(id)
            .then(() => {
              Constants.alert.fire(
                "Удаление",
                "Запись о роли удалена.",
                "success"
              );
              this.getTotalCount();
              this.loadPage();
            })
            .catch(() => {
              Constants.alert.fire(
                "Удаление",
                "Ошибка при удалении записи о роли.",
                "error"
              );
            });
        }
      });
    },
    onFiltersApply(filters) {
      this.filters = filters;
      this.request.pageNumber = 1;
      this.modals.filter = false;
      this.saveFilter(this.filters);
      this.isFiltered = true;
      this.loadPage();
    },
    onFiltersReset(filters) {
      this.filters = filters || {};
      this.request.pageNumber = 1;
      this.modals.filter = false;
      this.removeFilter();
      this.isFiltered = false;
      this.loadPage();
    },
  },
  computed: {
    ...mapState({
      page: (state) => state.admin.roles.listPage,
    }),
  },
  watch: {
    '$route.query.page': {
      handler(newVal) {
        this.request.pageNumber = newVal ? newVal * 1 : 1;
        this.loadPage();
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "/src/assets/theme/default/colors.scss";

.content {
  padding: 16px 16px 0 16px;
  position: relative;
  overflow-y: visible;
  .filter {
    position: absolute;
    width: 350px;
    height: auto;
    top: 0;
    right: 0;
    overflow: hidden;
    background-color: transparent;
    opacity: 1;
    transition: opacity 0.2s;
  }
  .filter-enter, .filter-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
}
.filtered {
  color: $red;
  &:hover {
    color: $red-dark;
  }
}
</style>
